import { API } from '../../../config';
import { errorHandler } from '../auth/errorAction';

export const unmountListTransaction = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_TRANSACTION'})
}

export const unmountDetailTransaction = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_TRANSACTION'})
}

export const unmountMasterTransaction = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_TRANSACTION'})
}

export const listTransaction = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_TRANSACTION' })
  return API.GET('/xpert/transaction/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_TRANSACTION_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_TRANSACTION_FAILED' }), 
    ))
  })
}

export const detailTransaction = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_TRANSACTION' })
  const params = {
    'id': id
  }
  API.GET('/xpert/transaction/getById', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_TRANSACTION_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_TRANSACTION_FAILED' }), 
      ))
    )
  })
}

export const masterTransaction = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_TRANSACTION' })
  return API.GET('/employers_type/index').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_TRANSACTION_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: null,
          total: null,
          perpage: null
        }
    }})
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_TRANSACTION_FAILED' }), 
    ))
  })
}

export const createTransaction = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA_ARRAY('/xpert/transaction/add', value, 'createTransaction').then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editTransaction = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA_ARRAY('/xpert/transaction/update', value, 'createTransaction').then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableTransaction = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/xpert/transaction/enable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableTransaction = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/xpert/transaction/disable', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const cancelTransaction = (value, successCB, failedCB) => () => {
  API.POST_WITH_PARAMS('/xpert/transaction/cancel', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const verifyTransaction = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/xpert/transaction/approve', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const rejectTransaction = (value, successCB, failedCB) => () => {
  API.POST_WITH_PARAMS('/xpert/transaction/reject', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}